import VueRouter from 'vue-router';
import Splash from './components/Splash';
import Home from './components/Home';
import Item from './components/Item';
import Cart from './components/Cart';
import OrderView from './components/OrderView';
import Payment from './components/payment/Payment';
import PaymentConfirm from './components/payment/Confirm';
import Popular from './components/Popular';
import Favorite from './components/Favorite';
import CategoryItem from './components/CategoryItem';
import Category from './components/Category';
import SearchHistory from './components/SearchHistory';
import SearchResult from './components/SearchResult';
import Content from './components/Content';
import Contribution from './components/request/Contribution';
import ContributionSend from './components/request/Send';

export default new VueRouter({
  routes: [
    {path: '/', component: Splash},
    {path: '/h', component: Home,
      children: [
        {path: 'popular/', component: Popular, name: 'popular'},
        {path: 'popular/:id', component: Item, name: 'popularItem'},
        {path: 'favorite/', component: Favorite, name: 'favorite'},
        {path: 'favorite/:id', component: Item, name: 'favoriteItem'},
        {path: 'searchHistory/', component: SearchHistory, name: 'searchHistory'},
        {path: 'category/', component: Category, name: 'category'},
        {path: 'category/:category/', component: CategoryItem, name: 'categoryCategory'},
        {path: 'category/:category/contribution', component: Contribution, name: 'categoryContribution'},
        {path: 'category/:category/:id', component: Item, name: 'categoryItem'},
      ]
    },
    {path: '/search_result/:searchText/', component: SearchResult, name: 'search'},
    {path: '/search_result/:searchText/contribution', component: Contribution, name: 'searchContribution'},
    {path: '/search_result/:searchText/:id', component: Item, name: 'searchItem'},
    {path: '/search_result', component: SearchResult},
    {path: '/cart', component: Cart},
    {path: '/order/:code', component: OrderView},
    // {path: '/order', component: Order},
    {path: '/payment/', component: Payment},
    {path: '/payment/confirm/done', component: () => import('./components/payment/Done')},
    {path: '/payment/confirm/:payment_method', component: PaymentConfirm},
    {path: '/contents/:code', component: Content},
    {path: '/contribution', component: Contribution, name: 'contribution'},
    {path: '/contribution/send', component: ContributionSend, name: 'contributionSend'},
    {path: '/calculation', component: () => import('./components/Calculation')},
    {path: '/:id', component: Item, name: 'directItem'},
  ],
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0};
  },
});
